<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料模板">
              <a-input v-model="form.templateName" :disabled="status === 'edit'" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="模板说明">
              <a-input v-model="form.description" :disabled="status === 'edit'" />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                :value.sync="form.organizationCode"
                :selectData="inventOrg"
              />
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24">
            <a-form-item label="模板状态">
              <a-switch :checked="form.templateStatus === 'Y'" @change="statusOnChange(form)" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button :loading="confirmLoading" type="primary" @click="save">保存</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="tableList"
          :pagination="false"
          row-key="id"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
            <div :key="item.dataIndex">
              <span v-if="item.type === 'inputOrSelect'">
                <a-select v-if="record.attribute14 === 'Y'" v-model="record[item.dataIndex]" size="small">
                  <a-select-option v-for="(col) in setArray(item.dataList2)" :key="col[item.ynvalue]">{{ col[item.ynlabel] }}</a-select-option>
                </a-select>
                <a-select show-search option-filter-prop="children" v-else-if="record.attribute15" v-model="record[item.dataIndex]" size="small" @focus="selectFocus(item.dataIndex, record)">
                  <a-select-option v-for="(col) in setArray(item.dataList)" :key="col[item.value]">{{ col[item.label] }}</a-select-option>
                </a-select>
                <a-input v-else-if="!record.attribute15" v-model="record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'switch'">
                <a-switch :checked="text === 'Y'" @change="statusOnChangeNew(record)" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </a-table>
        <!-- 底部分页按钮 -->
        <Page v-show="false" ref="page" :pageParams.sync="pageParams" @getList="getList" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiItemTemplateEdit, apiItemTemplateAdd, apiItemTemplateParameterValueBox } from '@/api/mdm/matter/material-template'
export default {
  // eslint-disable-next-line
  name: 'material-template-detail',
  data () {
    return {
      parameterValueList: [],
      pageParams: {
        automatic: false,
        pageUrl: "",
        tableLoading: false
      },
      isEdit: false,
      // 查询参数
      queryParams: {},
      form: {
        templateName: undefined,
        description: undefined,
        // organizationCode: undefined,
        templateStatus: "Y"
      },
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [],
      columns1: [
        {
          title: '属性名称',
          dataIndex: 'attributeName',
          width: 200,
          align: 'center'
        },
        {
          title: '值',
          dataIndex: 'attributeValue',
          scopedSlots: { customRender: 'attributeValue' },
          width: 200,
          align: 'center',
          type: "inputOrSelect",
          dataList: 'parameterValueList',
          dataList2: "yesOrNo",
          value: 'label',
          label: 'description',
          ynvalue: 'realValue',
          ynlabel: 'label'
        },
        {
          title: '启用',
          dataIndex: 'enabledFlag',
          scopedSlots: { customRender: 'enabledFlag' },
          align: 'center',
          type: "switch"
        }
      ],
      columns2: [
        {
          title: '最后修改人',
          dataIndex: 'updateBy',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createBy',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 160,
          align: 'center',
          type: "text"
        }
      ],
      yesOrNo: [
        {
          realValue: "Y",
          label: "是"
        },
        {
          realValue: "N",
          label: "否"
        }
      ],
      status: "", // 编辑 新增
      detailId: "",
      confirmLoading: false
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route (to, from) {
      this.editOrAdd()
      this.$refs.page.getFirstPage(this.queryParams)
    }
  },
  created () {
    this.editOrAdd()
  },
  mounted () {
    this.$refs.page.getFirstPage(this.queryParams)
  },
  methods: {
    // 保存
    save () {
      if (!this.form.templateName) {
        this.$message.error('物料模板不能为空')
        return
      }
      const params = {
        mdmItemTemplateAttributeDTOList: this.tableList,
        ...this.form
      }
      delete params.mdmItemTemplateAttributeVOList;
      this.confirmLoading = true
      if (this.status === "edit") {
        apiItemTemplateEdit(params).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // this.event.$emit("close-current-page");
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
      } else {
        apiItemTemplateAdd(params).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // this.event.$emit("close-current-page");
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
      }
    },
    /** 查询列表 */
    getList (data) {
      if (this.status === "edit") {
        this.form = data
        this.tableList = data.mdmItemTemplateAttributeVOList
      } else {
        this.tableList = data
      }
    },
    // 值-下拉框数据
    getParameterValueBox (record) {
      apiItemTemplateParameterValueBox({ id: record.attribute15, parameterCode: record.attributeCode }).then(res => {
        if (res.data && res.data.length > 0) {
          this.parameterValueList = res.data
        }
      })
    },
    // 值-下拉框数据-触发
    selectFocus (dataIndex, record) {
      if (dataIndex === "attributeValue") {
        this.getParameterValueBox(record)
      }
    },
    setArray (arr) {
      return this[arr]
    },
    // 状态处理
    editOrAdd () {
      this.status = this.$route.query.status || null;
      this.detailId = this.$route.query.id || null;
      if (this.status === "edit") {
        const columns1 = JSON.parse(JSON.stringify(this.columns1))
        const columns2 = JSON.parse(JSON.stringify(this.columns2))
        this.columns = columns1.concat(columns2)
        this.pageParams.pageUrl = `/mdm/itemTemplate/${this.detailId}`
      } else {
        this.columns = JSON.parse(JSON.stringify(this.columns1))
        this.pageParams.pageUrl = "/mdm/itemTemplate/addLineList"
      }
    },
    // 启用-切换
    statusOnChangeNew (record) {
      record.enabledFlag = record.enabledFlag === 'Y' ? 'N' : 'Y'
    },
    // 模板状态-切换
    statusOnChange (form) {
      form.templateStatus = form.templateStatus === 'Y' ? 'N' : 'Y'
    }
  }
}
</script>

<style scoped lang="less">
.page-header-content{
  /deep/.ant-select{
    width: 150px;
  }
  input{
    width: 150px;
  }
}
</style>
